const DELETED_TEMPLATE_SUFFIX = /_\d{8}_\d{6}$/;

/**
 * Parses a template name that may contain a deletion timestamp suffix.
 * Returns the clean display name and whether the template was deleted.
 */
const parseTemplateName = (
  templateName: string
): { displayName: string; isDeleted: boolean } => {
  const isDeleted = DELETED_TEMPLATE_SUFFIX.test(templateName);
  const displayName = templateName.replace(DELETED_TEMPLATE_SUFFIX, "");
  return { displayName, isDeleted };
};

export default parseTemplateName;
